import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from "../layout/index";
import axios from 'axios';
import { toast } from "react-toastify";
import { APP_ROUTES } from "../../constants/approutes";

const hasOrganizationOnboarded = () => {
    if (localStorage.getItem("organizationOnboarded") === "true") {
        return true;
    }
    const clinicId = localStorage.getItem("clinicId") || "";
    const clinicName = localStorage.getItem("clinicname") || "";
    const hospitalId = localStorage.getItem("hospitalid") || "";
    const categoryType = localStorage.getItem("categoryType");

    if (categoryType === "HOSPI360") {
        return Boolean(hospitalId.trim() || clinicId.trim() || clinicName.trim());
    }
    return Boolean(clinicId.trim() || clinicName.trim());
};

const ClinicStaffOnboard = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        // userId: '',
        firstName: '',
        middleName: '',
        lastName: '',
        mobile: '',
        email: '',
        roles: ['USER'],
        password: '',
        active: true,
        tenantId: localStorage.getItem("tenantId"),
        categoryType: localStorage.getItem("categoryType") || "SMARTCLINIC",
    });
    
    const [errors, setErrors] = useState({
        // userId: '',
        firstName: '',
        middleName: '',
        lastName: '',
        mobile: '',
        email: ''
    });
    
    const [isSubmitting, setIsSubmitting] = useState(false);
    const token = localStorage.getItem("auth_token");
    const API_BASE = process.env.REACT_APP_API_URL;
    const [receptionists, setReceptionists] = useState([]);
    const [userIdSuggestions, setUserIdSuggestions] = useState([]);
    useEffect(() => {
        fetchList();
    }, []);

    const generateUserIdSuggestions = (firstName, mobile, existingUserIds) => {
        const suggestions = [];
        
        if (firstName && mobile && mobile.length >= 4) {
            const firstNameLower = firstName.toLowerCase();
            const mobileLast4 = mobile.substring(mobile.length - 4);
            const suggestion = `${firstNameLower}@${mobileLast4}`;
            
            if (!existingUserIds.includes(suggestion.toLowerCase())) {
                suggestions.push(suggestion);
            }
        }
        
        return suggestions;
    };

    const isAlreadyStaff = async (field, value) => {
        if (!value) return false;
        try {
            const res = await axios.get(`${API_BASE}auth/fetch-user-details`, {
                params: { [field]: value },
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            const data = Array.isArray(res.data) ? res.data : [];
            return data.some((u) => Array.isArray(u?.roles) && u.roles.includes("USER"));
        } catch (error) {
            console.error(`Failed to check existing ${field}:`, error.response || error);
            return false;
        }
    };

    const fetchList = async () => {
        const token = localStorage.getItem("auth_token");
        const tenantId = localStorage.getItem("tenantId");

        try {
            const res = await fetch(
                `${API_BASE}auth/fetch-user-details`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                        // tenantId: tenantId,
                    },
                }
            );
            const data = await res.json();
            console.log(data, "receptionists");
            setReceptionists(data);
            // const userIdsString = data.map(receptionist => receptionist.userId).join(',');
            // console.log(userIdsString,"userIdsString");
            // setLoading(false);
        } catch (error) {
            console.error("Failed to fetch receptionist data:", error);
            toast.error("Failed to fetch receptionist data");
            // setLoading(false);
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        
        let filteredValue = value;
        
        // Filter input based on field type
        if (name === 'firstName' || name === 'middleName' || name === 'lastName') {
            // Only allow letters and spaces for name fields
            filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
        } else if (name === 'mobile') {
            // Only allow numbers for mobile field
            filteredValue = value.replace(/\D/g, '');
        }
        
        setFormData(prev => ({
            ...prev,
            [name]: filteredValue
        }));
        
        // Real-time validation on every keystroke
        validateField(name, filteredValue);
    };

    const validateField = (fieldName, value) => {
        let error = '';
        
        switch (fieldName) {
            // case 'userId':
            //     if (!value.trim()) {
            //         error = 'User ID is required';
            //     } else {
            //         // Check if userId already exists
            //         const existingUserIds = receptionists.map(r => r.userId.toLowerCase());
            //         if (existingUserIds.includes(value.toLowerCase())) {
            //             // Generate suggestion for the error message
            //             const suggestions = generateUserIdSuggestions(formData.firstName, formData.mobile, existingUserIds);
            //             if (suggestions.length > 0) {
            //                 error = `User ID already exists. Try a different one. Suggested: ${suggestions[0]}`;
            //             } else {
            //                 error = 'User ID already exists. Try a different one.';
            //             }
            //         }
            //     }
            //     break;
            case 'firstName':
                if (!value.trim()) {
                    error = 'First name is required';
                } else if (!/^[a-zA-Z\s]+$/.test(value.trim())) {
                    error = 'First name can only contain letters and spaces';
                }
                break;
            case 'middleName':
                if (value.trim() && !/^[a-zA-Z\s]+$/.test(value.trim())) {
                    error = 'Middle name can only contain letters and spaces';
                }
                break;
            case 'lastName':
                if (value.trim() && !/^[a-zA-Z\s]+$/.test(value.trim())) {
                    error = 'Last name can only contain letters and spaces';
                }
                break;
            case 'mobile':
                if (!value.trim()) {
                    error = 'Mobile number is required';
                } else if (!/^\d{10}$/.test(value)) {
                    error = 'Please enter a valid 10-digit mobile number';
                }
                break;
            case 'email':
                if (!value.trim()) {
                    error = 'Email is required';
                } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                    error = 'Please enter a valid email address';
                }
                break;
            default:
                break;
        }
        
        setErrors(prev => ({
            ...prev,
            [fieldName]: error
        }));
    };

    const validateForm = () => {
        let valid = true;
        const newErrors = {
            // userId: '',
            firstName: '',
            middleName: '',
            lastName: '',
            mobile: '',
            email: ''
        };

        // if (!formData.userId.trim()) {
        //     newErrors.userId = 'User ID is required';
        //     valid = false;
        // } else {
        //     // Check if userId already exists
        //     const existingUserIds = receptionists.map(r => r.userId.toLowerCase());
        //     if (existingUserIds.includes(formData.userId.toLowerCase())) {
        //         // Generate suggestion for the error message
        //         const suggestions = generateUserIdSuggestions(formData.firstName, formData.mobile, existingUserIds);
        //         if (suggestions.length > 0) {
        //             newErrors.userId = `User ID already exists. Try a different one. Suggested: ${suggestions[0]}`;
        //         } else {
        //             newErrors.userId = 'User ID already exists. Try a different one.';
        //         }
        //         valid = false;
        //     }
        // }

        if (!formData.firstName.trim()) {
            newErrors.firstName = 'First name is required';
            valid = false;
        } else if (!/^[a-zA-Z\s]+$/.test(formData.firstName.trim())) {
            newErrors.firstName = 'First name can only contain letters and spaces';
            valid = false;
        }

        // Validate middle name if provided
        if (formData.middleName.trim() && !/^[a-zA-Z\s]+$/.test(formData.middleName.trim())) {
            newErrors.middleName = 'Middle name can only contain letters and spaces';
            valid = false;
        }

        // Validate last name if provided
        if (formData.lastName.trim() && !/^[a-zA-Z\s]+$/.test(formData.lastName.trim())) {
            newErrors.lastName = 'Last name can only contain letters and spaces';
            valid = false;
        }

        if (!formData.mobile.trim()) {
            newErrors.mobile = 'Mobile number is required';
            valid = false;
        } else if (!/^\d{10}$/.test(formData.mobile)) {
            newErrors.mobile = 'Please enter a valid 10-digit mobile number';
            valid = false;
        }

        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
            valid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = 'Please enter a valid email address';
            valid = false;
        }

        setErrors(newErrors);
        return valid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        if (!hasOrganizationOnboarded()) {
            toast.error(
                "Please onboard organization information first before adding staff."
            );
            setIsSubmitting(false);
            return;
        }
        
        if (!validateForm()) {
            setIsSubmitting(false);
            return;
        }

        const [emailIsStaff, mobileIsStaff] = await Promise.all([
            isAlreadyStaff("email", formData.email),
            isAlreadyStaff("mobile", formData.mobile),
        ]);

        if (emailIsStaff) {
            toast.error("This email is already registered as a Staff.");
            setIsSubmitting(false);
            return;
        }
        if (mobileIsStaff) {
            toast.error("This mobile number is already registered as a Staff.");
            setIsSubmitting(false);
            return;
        }

        try {
            const categoryType = localStorage.getItem("categoryType") || "SMARTCLINIC";
            const registerPayload = {
                ...formData,
                categoryType,
            };

            const res = await axios.post(
                `${API_BASE}auth/register`,
                registerPayload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            // const result = await res.json();
            console.log(res.data?.data, "result");

            // Second API call with tenantId in header
            if(res.status == 200) {
                const payloadWithId = {
                    ...registerPayload,
                    userId: res.data?.data
                };
                
                const secondApiResponse = await axios.post(
                    `${API_BASE}auth/register`, // Replace with your actual endpoint
                    payloadWithId,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                            tenantId: localStorage.getItem("tenantId")
                        }
                    }
                );
                if(secondApiResponse.status == 200) {
                    toast.success("Staff onboarded successfully");
                }  
              
            } else  {
               
                // You can decide whether to show an error or continue
                toast.warning("Staff registered but additional setup failed");
            }
            
          
            setFormData({
                userId: '',
                firstName: '',
                middleName: '',
                lastName: '',
                mobile: '',
                email: '',
                roles: ['USER'],
                password: '',
                active: true,
                tenantId: localStorage.getItem("tenantId"),
                categoryType: localStorage.getItem("categoryType"),
            });

        } catch (err) {
            console.error("Onboarding error:", err.response || err);
            const errorMessage = err.response?.data?.error || 
                               err.response?.data?.message || 
                               "Failed to onboard staff. Please try again.";
            toast.error(errorMessage);
        } finally {
            setIsSubmitting(false);
        }
    };
    const userIdsString = receptionists.map(receptionist => receptionist.userId).join(',');
    console.log(userIdsString,"userIdsString");
    return (
        <DashboardLayout>
            <div className="w-full mx-auto bg-[#f1f8f7] p-6 rounded-lg shadow-md mt-10 max-w-4xl">
                <h1 className="text-2xl font-bold text-[#004276] mb-6">Onboard Organization Staff</h1>

                {!hasOrganizationOnboarded() && (
                    <div className="mb-6 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-amber-900">
                        <p className="text-sm font-medium">
                            Organization information is not onboarded yet. Please complete organization
                            onboarding before adding staff.
                        </p>
                        <button
                            type="button"
                            onClick={() => navigate(APP_ROUTES.CLINIC_ONBOARDING)}
                            className="mt-2 text-sm font-semibold text-[#004276] underline hover:text-[#00BD7F]"
                        >
                            Go to Organization Onboarding
                        </button>
                    </div>
                )}

                <form onSubmit={handleSubmit} noValidate>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* <div className="mb-4">
                            <label className="block text-[#004276] font-medium mb-2" htmlFor="userId">
                                User ID *
                            </label>
                            <input
                                type="text"
                                id="userId"
                                name="userId"
                                placeholder="Enter user ID ex- firstname@last 4 digit of mobile number"
                                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                                    errors.userId ? 
                                    'border-red-500 focus:ring-red-500' : 
                                    'border-gray-300 focus:ring-blue-500'
                                }`}
                                value={formData.userId}
                                onChange={handleChange}
                            />
                            {errors.userId && (
                                <p className="mt-1 text-sm text-red-600">{errors.userId}</p>
                            )}
                        </div> */}

                        <div className="mb-4">
                            <label className="block text-[#004276] font-medium mb-2" htmlFor="firstName">
                                First Name *
                            </label>
                            <input
                                type="text"
                                id="firstName"
                                name="firstName"
                                placeholder="Enter first name"
                                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                                    errors.firstName ? 
                                    'border-red-500 focus:ring-red-500' : 
                                    'border-gray-300 focus:ring-blue-500'
                                }`}
                                value={formData.firstName}
                                onChange={handleChange}
                            />
                            {errors.firstName && (
                                <p className="mt-1 text-sm text-red-600">{errors.firstName}</p>
                            )}
                        </div>

                        <div className="mb-4">
                            <label className="block text-[#004276] font-medium mb-2" htmlFor="middleName">
                                Middle Name
                            </label>
                            <input
                                type="text"
                                id="middleName"
                                name="middleName"
                                placeholder="Enter middle name"
                                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                                    errors.middleName ? 
                                    'border-red-500 focus:ring-red-500' : 
                                    'border-gray-300 focus:ring-blue-500'
                                }`}
                                value={formData.middleName}
                                onChange={handleChange}
                            />
                            {errors.middleName && (
                                <p className="mt-1 text-sm text-red-600">{errors.middleName}</p>
                            )}
                        </div>

                        <div className="mb-4">
                            <label className="block text-[#004276] font-medium mb-2" htmlFor="lastName">
                                Last Name
                            </label>
                            <input
                                type="text"
                                id="lastName"
                                name="lastName"
                                placeholder="Enter last name"
                                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                                    errors.lastName ? 
                                    'border-red-500 focus:ring-red-500' : 
                                    'border-gray-300 focus:ring-blue-500'
                                }`}
                                value={formData.lastName}
                                onChange={handleChange}
                            />
                            {errors.lastName && (
                                <p className="mt-1 text-sm text-red-600">{errors.lastName}</p>
                            )}
                        </div>

                        <div className="mb-4">
                            <label className="block text-[#004276] font-medium mb-2" htmlFor="mobile">
                                Mobile *
                            </label>
                            <input
                                type="tel"
                                id="mobile"
                                name="mobile"
                                placeholder="Enter mobile number"
                                maxLength="10"
                                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                                    errors.mobile ? 
                                    'border-red-500 focus:ring-red-500' : 
                                    'border-gray-300 focus:ring-blue-500'
                                }`}
                                value={formData.mobile}
                                onChange={handleChange}
                            />
                            {errors.mobile && (
                                <p className="mt-1 text-sm text-red-600">{errors.mobile}</p>
                            )}
                        </div>

                        <div className="mb-4">
                            <label className="block text-[#004276] font-medium mb-2" htmlFor="email">
                                Email *
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                placeholder="Enter email"
                                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                                    errors.email ? 
                                    'border-red-500 focus:ring-red-500' : 
                                    'border-gray-300 focus:ring-blue-500'
                                }`}
                                value={formData.email}
                                onChange={handleChange}
                            />
                            {errors.email && (
                                <p className="mt-1 text-sm text-red-600">{errors.email}</p>
                            )}
                        </div>
                    </div>

                    <div className="flex justify-end space-x-4 mt-6">
                        <button
                            type="button"
                            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onClick={() => {
                                setFormData({
                                    // userId: '',
                                    firstName: '',
                                    middleName: '',
                                    lastName: '',
                                    mobile: '',
                                    email: '',
                                    roles: ['USER'],
                                    password: '',
                                    active: true,
                                    tenantId: localStorage.getItem("tenantId")
                                });
                                setErrors({
                                    // userId: '',
                                    firstName: '',
                                    middleName: '',
                                    lastName: '',
                                    mobile: '',
                                    email: ''
                                });
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={`px-4 py-2 bg-gradient-to-r from-[#004172] to-[#3cba84] text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                                isSubmitting ? 'opacity-70 cursor-not-allowed' : 'hover:opacity-90'
                            }`}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Processing...' : 'Onboard Staff'}
                        </button>
                    </div>
                </form>
            </div>
        </DashboardLayout>
    );
};

export default ClinicStaffOnboard;